/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { CONTAINER_SIZE, DIALOG_SIZE, WINDOW_WIDTH } from "src/libs/interfaces/layouts";
import { ILandingSection, ISectionComposition } from "../data/interfaces";
import useLandingSize from "./useLandingSize";
import { ILandingConsoleStore, useLandingConsoleStore } from "../data/store";

export function useComposition (section: ILandingSection, columnsSource: any = {}): ISectionComposition {
    const sizes                         = useLandingSize()
    const currentDimensionEdit          = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    const width                         = Math.min( sizes.width, currentDimensionEdit )
    const [composition, setComposition] = useState<ISectionComposition>(section?.composition || {})

    const setNewComposition = () => {
        const wc = width >= WINDOW_WIDTH.TABLET && !!section
            ? 
            section.composition.container === DIALOG_SIZE.LARGE || section.composition.container === DIALOG_SIZE.FULL
                ?
                width - 40
                :
                CONTAINER_SIZE[ section.composition.container || DIALOG_SIZE.NORMAL ]
            :
            width;
        
        const source = !!columnsSource.columns ? columnsSource : section?.composition
        const columns =  width >= WINDOW_WIDTH.SCREEN
            ?
            source?.columns
            :
            width > WINDOW_WIDTH.TABLET
                ?
                source?.columns > 3 ? 3 : 1
                :
                width >= WINDOW_WIDTH.MOBILE
                    ?
                    source?.columns > 2 ? 2 : 1
                    : 
                    1
        
        const proportia = !!section && section.composition.proportia?.length !== section.data?.length
            ?
            Array(section.data?.length || columns || 1).fill(1).map((_, i) => 100 / columns )
            :
            !!section.composition.proportia && width >= WINDOW_WIDTH.SCREEN
                ?
                section.composition.proportia
                :
                Array(section.data?.length || columns || 1).fill(1).map( (_, i) => {
                    if(  i > section.data?.length - columns ) {
                        return 100
                    }
                    return 100 / columns 
                })

        setComposition({
            ...section?.composition,
            width:  wc,
            columns,
            proportia,
            debug: {
                width
            }
        }) 
    }

    useEffect(() => {
        setNewComposition()
    }, [ width, section])
 
    return composition
}